import * as types from '../../components/Question/types';
import * as mathSymbols from '../../mathSymbols';

export const subtract1Questions: types.Question[] = [
  {
    numA: 1, sign: mathSymbols.SUB, numB: 1, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 1, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 1, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 1, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const subtract2Questions: types.Question[] = [
  {
    numA: 2, sign: mathSymbols.SUB, numB: 2, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 2, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 2, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 2, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const differenceQuestions: types.Question[] = [
  {
    numA: 0, sign: mathSymbols.SUB, numB: 0, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 0, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 0, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 0, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 0, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 0, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 0, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 0, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 0, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 0, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 0, answer: 11, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 0, answer: 12, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 0, answer: 13, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 0, answer: 14, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 0, answer: 15, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 0, answer: 16, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 0, answer: 17, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 0, answer: 18, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 0, answer: 19, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 0, answer: 20, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.SUB, numB: 0, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 1, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 2, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 3, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 4, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 5, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 6, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 7, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 8, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 9, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 11, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 12, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 13, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 14, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 15, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 16, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 17, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 18, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 19, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 20, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 0, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 1, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 2, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 3, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 4, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 5, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 6, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 7, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 8, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 11, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 12, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 13, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 14, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 15, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 16, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 17, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 18, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 19, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.SUB, numB: 0, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 0, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 0, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 0, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 0, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 0, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 0, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 0, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 0, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 0, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 0, answer: 11, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 0, answer: 12, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 0, answer: 13, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 0, answer: 14, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 0, answer: 15, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 0, answer: 16, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 0, answer: 17, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 0, answer: 18, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 0, answer: 19, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 0, answer: 20, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 0, sign: mathSymbols.SUB, numB: 0, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 1, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 2, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 3, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 4, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 5, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 6, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 7, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 8, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 9, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 11, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 12, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 13, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 14, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 15, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 16, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 17, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 18, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 19, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 20, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 0, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 1, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 2, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 3, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 4, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 5, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 6, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 7, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 8, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 11, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 12, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 13, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 14, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 15, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 16, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 17, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 18, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 19, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const subtract10Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 10, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 10, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 10, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 10, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 10, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 10, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 10, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 10, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 10, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 10, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 10, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 10, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 10, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 10, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 10, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 10, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const subtractFrom10Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation5, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation7, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const subtractAcross10Within20Questions: types.Question[] = [
  {
    numA: 11, sign: mathSymbols.SUB, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 3, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 4, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 5, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 6, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 7, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 8, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 9, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 5, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 6, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 7, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 8, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 9, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 10, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 11, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 4, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 5, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 6, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 7, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 8, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 9, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 10, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 11, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 12, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 5, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 6, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 7, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 8, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 9, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 10, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 11, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 12, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 13, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 6, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 7, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 8, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 9, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 10, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 11, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 12, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 13, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 14, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 7, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 8, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 9, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 10, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 11, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 12, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 13, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 14, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 15, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 8, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 9, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 10, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 11, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 12, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 13, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 14, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 15, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 16, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 9, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 10, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 11, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 12, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 13, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 14, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 15, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 16, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 17, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 10, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 11, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 12, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 13, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 14, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 15, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 16, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 17, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 18, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 3, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 4, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 5, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 6, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 7, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 8, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 9, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 5, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 6, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 7, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 8, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 9, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 10, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 11, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 4, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 5, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 6, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 7, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 8, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 9, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 10, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 11, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 12, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 5, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 6, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 7, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 8, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 9, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 10, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 11, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 12, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 13, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 6, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 7, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 8, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 9, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 10, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 11, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 12, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 13, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 14, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 7, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 8, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 9, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 10, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 11, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 12, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 13, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 14, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 15, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 8, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 9, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 10, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 11, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 12, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 13, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 14, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 15, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 16, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 9, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 10, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 11, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 12, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 13, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 14, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 15, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 16, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 17, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 10, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 11, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 12, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 13, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 14, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 15, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 16, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 17, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 18, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const subtractWithin10Questions: types.Question[] = [
  {
    numA: 1, sign: mathSymbols.SUB, numB: 0, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 0, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 1, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 0, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 2, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 0, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 3, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 0, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 3, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 4, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 0, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 3, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 4, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 5, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 0, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 3, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 4, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 5, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 6, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 0, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 3, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 4, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 5, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 6, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 7, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 0, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 4, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 5, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 6, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 7, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 8, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation1, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.SUB, numB: 0, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 0, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.SUB, numB: 1, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 0, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.SUB, numB: 2, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 0, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.SUB, numB: 3, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 0, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 3, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.SUB, numB: 4, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 0, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 3, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 4, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.SUB, numB: 5, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 0, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 3, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 4, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 5, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.SUB, numB: 6, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 0, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 3, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 4, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 5, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 6, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.SUB, numB: 7, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 0, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 4, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 5, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 6, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 7, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.SUB, numB: 8, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 0, answer: 10, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation2, hint: types.Hint.TEN_FRAME_SUBTRACT
  } as types.Question
];

export const subtractTensQuestions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 20, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 20, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 30, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 20, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 30, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 40, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 20, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 30, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 40, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 50, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 20, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 30, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 40, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 50, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 60, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 20, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 30, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 40, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 50, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 60, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 70, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 20, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 30, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 40, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 50, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 60, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 70, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 80, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 20, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 30, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 40, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 50, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 60, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 70, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 80, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 90, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 20, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 20, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 30, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 20, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 30, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 40, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 20, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 30, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 40, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 50, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 20, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 30, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 40, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 50, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 60, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 20, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 30, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 40, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 50, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 60, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 70, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 20, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 30, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 40, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 50, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 60, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 70, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 80, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 20, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 30, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 40, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 50, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 60, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 70, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 80, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 90, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question
];

export const subtractOnesWithin100Questions: types.Question[] = [
  {
    numA: 11, sign: mathSymbols.SUB, numB: 1, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 1, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 2, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 3, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 1, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 3, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 4, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 1, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 2, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 3, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 4, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 1, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 2, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 3, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 4, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 5, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 6, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 1, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 2, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 3, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 4, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 5, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 6, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 7, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 1, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 2, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 3, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 4, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 5, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 7, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 8, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 1, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 2, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 3, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 4, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 5, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 6, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 7, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 8, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 9, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 1, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 1, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 2, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 1, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 2, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 3, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 1, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 2, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 3, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 4, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 1, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 2, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 3, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 4, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 5, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 1, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 2, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 3, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 4, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 5, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 6, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 1, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 2, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 3, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 4, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 5, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 6, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 7, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 1, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 2, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 3, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 4, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 5, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 6, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 7, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 8, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 1, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 2, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 3, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 4, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 5, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 6, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 7, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 8, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 9, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 1, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 1, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 2, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 1, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 2, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 3, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 1, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 2, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 3, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 4, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 1, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 2, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 3, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 4, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 5, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 1, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 2, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 3, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 4, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 5, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 6, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 1, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 2, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 3, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 4, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 5, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 6, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 7, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 1, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 2, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 3, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 4, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 5, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 6, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 7, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 8, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 1, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 2, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 3, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 4, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 5, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 6, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 7, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 8, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 9, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 1, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 1, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 2, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 1, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 2, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 3, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 1, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 2, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 3, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 4, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 1, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 2, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 3, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 4, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 5, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 1, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 2, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 3, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 4, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 5, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 6, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 1, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 2, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 3, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 4, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 5, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 6, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 7, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 1, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 2, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 3, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 4, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 5, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 6, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 7, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 8, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 1, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 2, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 3, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 4, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 5, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 6, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 7, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 8, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 9, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 1, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 1, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 2, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 1, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 2, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 3, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 1, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 2, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 3, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 4, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 1, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 2, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 3, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 4, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 5, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 1, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 2, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 3, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 4, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 5, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 6, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 1, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 2, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 3, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 4, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 5, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 6, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 7, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 1, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 2, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 3, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 4, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 5, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 6, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 7, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 8, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 1, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 2, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 3, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 4, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 5, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 6, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 7, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 8, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 9, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 1, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 1, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 2, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 1, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 2, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 3, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 1, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 2, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 3, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 4, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 1, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 2, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 3, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 4, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 5, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 1, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 2, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 3, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 4, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 5, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 6, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 1, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 2, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 3, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 4, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 5, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 6, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 7, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 1, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 2, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 3, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 4, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 5, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 6, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 7, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 8, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 1, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 2, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 3, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 4, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 5, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 6, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 7, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 8, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 9, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 1, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 1, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 2, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 1, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 2, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 3, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 1, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 2, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 3, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 4, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 1, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 2, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 3, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 4, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 5, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 1, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 2, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 3, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 4, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 5, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 6, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 1, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 2, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 3, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 4, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 5, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 6, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 7, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 1, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 2, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 3, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 4, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 5, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 6, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 7, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 8, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 1, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 2, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 3, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 4, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 5, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 6, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 7, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 8, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 9, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 1, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 1, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 2, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 1, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 2, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 3, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 1, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 2, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 3, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 4, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 1, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 2, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 3, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 4, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 5, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 1, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 2, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 3, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 4, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 5, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 6, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 1, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 2, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 3, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 4, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 5, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 6, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 7, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 1, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 2, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 3, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 4, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 5, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 6, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 7, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 8, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 1, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 2, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 3, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 4, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 5, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 6, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 7, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 8, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 9, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 1, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 1, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 2, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 1, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 2, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 3, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 1, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 2, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 3, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 4, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 1, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 2, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 3, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 4, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 5, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 1, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 2, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 3, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 4, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 5, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 6, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 1, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 2, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 3, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 4, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 5, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 6, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 7, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 1, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 2, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 3, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 4, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 5, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 6, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 7, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 8, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 1, answer: 98, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 2, answer: 97, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 3, answer: 96, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 4, answer: 95, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 5, answer: 94, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 6, answer: 93, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 7, answer: 92, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 8, answer: 91, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 9, answer: 90, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 1, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 1, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 2, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 3, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 1, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 3, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 4, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 1, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 2, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 3, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 4, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 1, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 2, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 3, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 4, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 5, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 6, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 1, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 2, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 3, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 4, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 5, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 6, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 7, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 1, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 2, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 3, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 4, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 5, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 7, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 8, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 1, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 2, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 3, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 4, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 5, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 6, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 7, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 8, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 9, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 1, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 1, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 2, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 1, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 2, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 3, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 1, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 2, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 3, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 4, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 1, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 2, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 3, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 4, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 5, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 1, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 2, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 3, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 4, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 5, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 6, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 1, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 2, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 3, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 4, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 5, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 6, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 7, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 1, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 2, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 3, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 4, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 5, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 6, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 7, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 8, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 1, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 2, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 3, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 4, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 5, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 6, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 7, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 8, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 9, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 1, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 1, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 2, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 1, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 2, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 3, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 1, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 2, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 3, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 4, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 1, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 2, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 3, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 4, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 5, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 1, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 2, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 3, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 4, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 5, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 6, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 1, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 2, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 3, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 4, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 5, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 6, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 7, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 1, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 2, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 3, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 4, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 5, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 6, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 7, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 8, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 1, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 2, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 3, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 4, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 5, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 6, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 7, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 8, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 9, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 1, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 1, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 2, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 1, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 2, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 3, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 1, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 2, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 3, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 4, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 1, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 2, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 3, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 4, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 5, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 1, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 2, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 3, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 4, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 5, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 6, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 1, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 2, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 3, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 4, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 5, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 6, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 7, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 1, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 2, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 3, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 4, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 5, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 6, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 7, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 8, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 1, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 2, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 3, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 4, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 5, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 6, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 7, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 8, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 9, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 1, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 1, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 2, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 1, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 2, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 3, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 1, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 2, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 3, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 4, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 1, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 2, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 3, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 4, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 5, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 1, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 2, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 3, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 4, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 5, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 6, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 1, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 2, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 3, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 4, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 5, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 6, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 7, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 1, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 2, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 3, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 4, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 5, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 6, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 7, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 8, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 1, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 2, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 3, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 4, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 5, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 6, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 7, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 8, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 9, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 1, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 1, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 2, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 1, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 2, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 3, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 1, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 2, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 3, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 4, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 1, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 2, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 3, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 4, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 5, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 1, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 2, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 3, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 4, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 5, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 6, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 1, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 2, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 3, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 4, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 5, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 6, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 7, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 1, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 2, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 3, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 4, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 5, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 6, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 7, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 8, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 1, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 2, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 3, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 4, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 5, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 6, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 7, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 8, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 9, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 1, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 1, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 2, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 1, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 2, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 3, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 1, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 2, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 3, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 4, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 1, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 2, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 3, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 4, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 5, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 1, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 2, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 3, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 4, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 5, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 6, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 1, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 2, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 3, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 4, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 5, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 6, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 7, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 1, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 2, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 3, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 4, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 5, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 6, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 7, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 8, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 1, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 2, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 3, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 4, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 5, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 6, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 7, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 8, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 9, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 1, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 1, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 2, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 1, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 2, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 3, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 1, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 2, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 3, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 4, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 1, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 2, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 3, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 4, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 5, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 1, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 2, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 3, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 4, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 5, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 6, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 1, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 2, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 3, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 4, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 5, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 6, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 7, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 1, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 2, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 3, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 4, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 5, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 6, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 7, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 8, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 1, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 2, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 3, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 4, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 5, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 6, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 7, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 8, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 9, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 1, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 1, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 2, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 1, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 2, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 3, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 1, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 2, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 3, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 4, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 1, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 2, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 3, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 4, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 5, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 1, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 2, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 3, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 4, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 5, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 6, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 1, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 2, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 3, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 4, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 5, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 6, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 7, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 1, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 2, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 3, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 4, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 5, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 6, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 7, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 8, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 1, answer: 98, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 2, answer: 97, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 3, answer: 96, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 4, answer: 95, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 5, answer: 94, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 6, answer: 93, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 7, answer: 92, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 8, answer: 91, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 9, answer: 90, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question
];

export const subtractAcrossTensWithin100Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 3, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 4, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 5, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 6, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 7, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 8, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 9, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 11, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 5, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 6, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 7, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 8, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 9, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 10, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 11, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 12, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 4, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 5, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 6, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 7, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 8, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 9, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 10, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 11, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 12, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 13, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 5, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 6, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 7, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 8, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 9, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 10, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 11, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 12, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 13, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 14, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 6, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 7, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 8, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 9, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 10, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 11, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 12, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 13, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 14, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 15, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 7, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 8, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 9, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 10, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 11, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 12, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 13, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 14, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 15, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 16, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 8, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 9, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 10, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 11, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 12, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 13, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 14, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 15, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 16, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 17, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 9, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 10, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 11, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 12, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 13, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 14, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 15, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 16, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 17, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 18, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 10, answer: 9, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 11, answer: 8, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 12, answer: 7, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 13, answer: 6, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 14, answer: 5, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 15, answer: 4, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 16, answer: 3, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 17, answer: 2, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 18, answer: 1, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 19, answer: 0, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 1, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 2, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 3, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 4, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 5, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 6, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 7, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 8, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 9, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 2, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 3, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 4, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 5, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 6, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 7, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 8, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 9, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 10, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 11, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 3, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 4, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 5, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 6, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 7, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 8, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 9, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 10, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 11, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 12, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 4, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 5, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 6, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 7, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 8, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 9, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 10, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 11, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 12, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 13, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 5, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 6, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 7, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 8, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 9, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 10, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 11, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 12, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 13, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 14, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 6, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 7, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 8, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 9, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 10, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 11, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 12, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 13, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 14, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 15, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 7, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 8, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 9, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 10, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 11, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 12, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 13, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 14, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 15, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 16, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 8, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 9, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 10, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 11, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 12, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 13, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 14, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 15, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 16, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 17, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 9, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 10, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 11, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 12, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 13, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 14, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 15, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 16, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 17, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 18, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 10, answer: 19, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 11, answer: 18, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 12, answer: 17, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 13, answer: 16, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 14, answer: 15, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 15, answer: 14, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 16, answer: 13, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 17, answer: 12, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 18, answer: 11, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 19, answer: 10, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 1, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 2, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 3, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 4, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 5, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 6, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 7, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 8, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 9, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 2, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 3, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 4, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 5, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 6, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 7, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 8, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 9, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 10, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 11, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 3, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 4, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 5, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 6, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 7, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 8, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 9, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 10, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 11, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 12, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 4, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 5, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 6, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 7, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 8, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 9, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 10, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 11, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 12, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 13, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 5, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 6, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 7, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 8, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 9, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 10, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 11, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 12, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 13, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 14, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 6, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 7, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 8, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 9, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 10, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 11, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 12, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 13, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 14, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 15, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 7, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 8, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 9, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 10, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 11, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 12, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 13, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 14, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 15, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 16, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 8, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 9, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 10, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 11, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 12, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 13, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 14, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 15, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 16, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 17, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 9, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 10, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 11, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 12, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 13, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 14, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 15, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 16, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 17, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 18, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 10, answer: 29, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 11, answer: 28, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 12, answer: 27, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 13, answer: 26, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 14, answer: 25, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 15, answer: 24, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 16, answer: 23, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 17, answer: 22, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 18, answer: 21, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 19, answer: 20, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 1, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 2, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 3, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 4, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 5, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 6, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 7, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 8, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 9, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 2, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 3, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 4, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 5, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 6, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 7, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 8, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 9, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 10, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 11, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 3, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 4, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 5, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 6, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 7, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 8, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 9, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 10, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 11, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 12, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 4, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 5, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 6, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 7, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 8, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 9, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 10, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 11, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 12, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 13, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 5, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 6, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 7, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 8, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 9, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 10, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 11, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 12, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 13, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 14, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 6, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 7, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 8, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 9, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 10, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 11, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 12, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 13, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 14, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 15, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 7, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 8, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 9, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 10, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 11, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 12, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 13, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 14, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 15, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 16, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 8, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 9, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 10, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 11, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 12, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 13, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 14, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 15, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 16, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 17, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 9, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 10, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 11, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 12, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 13, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 14, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 15, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 16, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 17, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 18, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 10, answer: 39, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 11, answer: 38, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 12, answer: 37, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 13, answer: 36, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 14, answer: 35, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 15, answer: 34, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 16, answer: 33, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 17, answer: 32, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 18, answer: 31, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 19, answer: 30, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 1, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 2, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 3, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 4, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 5, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 6, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 7, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 8, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 9, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 2, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 3, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 4, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 5, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 6, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 7, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 8, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 9, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 10, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 11, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 3, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 4, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 5, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 6, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 7, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 8, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 9, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 10, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 11, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 12, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 4, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 5, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 6, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 7, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 8, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 9, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 10, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 11, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 12, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 13, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 5, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 6, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 7, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 8, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 9, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 10, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 11, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 12, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 13, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 14, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 6, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 7, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 8, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 9, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 10, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 11, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 12, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 13, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 14, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 15, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 7, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 8, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 9, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 10, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 11, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 12, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 13, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 14, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 15, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 16, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 8, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 9, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 10, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 11, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 12, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 13, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 14, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 15, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 16, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 17, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 9, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 10, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 11, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 12, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 13, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 14, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 15, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 16, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 17, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 18, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 10, answer: 49, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 11, answer: 48, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 12, answer: 47, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 13, answer: 46, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 14, answer: 45, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 15, answer: 44, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 16, answer: 43, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 17, answer: 42, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 18, answer: 41, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 19, answer: 40, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 1, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 2, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 3, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 4, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 5, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 6, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 7, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 8, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 9, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 2, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 3, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 4, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 5, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 6, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 7, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 8, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 9, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 10, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 11, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 3, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 4, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 5, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 6, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 7, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 8, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 9, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 10, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 11, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 12, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 4, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 5, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 6, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 7, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 8, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 9, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 10, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 11, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 12, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 13, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 5, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 6, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 7, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 8, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 9, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 10, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 11, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 12, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 13, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 14, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 6, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 7, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 8, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 9, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 10, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 11, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 12, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 13, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 14, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 15, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 7, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 8, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 9, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 10, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 11, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 12, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 13, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 14, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 15, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 16, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 8, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 9, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 10, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 11, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 12, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 13, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 14, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 15, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 16, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 17, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 9, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 10, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 11, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 12, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 13, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 14, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 15, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 16, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 17, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 18, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 10, answer: 59, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 11, answer: 58, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 12, answer: 57, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 13, answer: 56, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 14, answer: 55, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 15, answer: 54, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 16, answer: 53, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 17, answer: 52, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 18, answer: 51, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 19, answer: 50, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 1, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 2, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 3, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 4, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 5, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 6, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 7, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 8, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 9, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 2, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 3, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 4, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 5, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 6, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 7, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 8, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 9, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 10, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 11, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 3, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 4, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 5, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 6, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 7, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 8, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 9, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 10, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 11, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 12, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 4, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 5, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 6, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 7, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 8, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 9, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 10, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 11, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 12, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 13, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 5, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 6, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 7, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 8, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 9, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 10, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 11, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 12, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 13, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 14, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 6, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 7, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 8, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 9, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 10, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 11, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 12, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 13, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 14, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 15, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 7, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 8, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 9, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 10, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 11, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 12, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 13, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 14, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 15, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 16, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 8, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 9, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 10, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 11, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 12, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 13, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 14, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 15, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 16, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 17, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 9, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 10, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 11, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 12, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 13, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 14, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 15, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 16, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 17, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 18, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 10, answer: 69, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 11, answer: 68, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 12, answer: 67, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 13, answer: 66, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 14, answer: 65, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 15, answer: 64, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 16, answer: 63, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 17, answer: 62, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 18, answer: 61, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 19, answer: 60, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 1, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 2, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 3, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 4, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 5, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 6, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 7, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 8, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 9, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 2, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 3, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 4, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 5, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 6, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 7, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 8, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 9, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 10, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 11, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 3, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 4, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 5, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 6, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 7, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 8, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 9, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 10, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 11, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 12, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 4, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 5, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 6, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 7, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 8, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 9, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 10, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 11, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 12, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 13, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 5, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 6, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 7, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 8, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 9, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 10, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 11, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 12, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 13, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 14, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 6, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 7, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 8, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 9, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 10, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 11, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 12, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 13, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 14, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 15, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 7, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 8, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 9, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 10, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 11, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 12, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 13, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 14, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 15, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 16, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 8, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 9, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 10, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 11, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 12, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 13, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 14, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 15, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 16, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 17, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 9, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 10, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 11, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 12, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 13, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 14, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 15, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 16, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 17, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 18, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 10, answer: 79, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 11, answer: 78, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 12, answer: 77, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 13, answer: 76, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 14, answer: 75, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 15, answer: 74, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 16, answer: 73, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 17, answer: 72, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 18, answer: 71, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 19, answer: 70, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 1, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 2, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 3, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 4, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 5, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 6, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 7, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 8, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 9, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 2, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 3, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 4, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 5, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 6, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 7, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 8, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 9, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 10, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 11, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 3, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 4, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 5, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 6, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 7, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 8, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 9, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 10, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 11, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 12, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 4, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 5, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 6, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 7, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 8, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 9, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 10, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 11, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 12, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 13, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 5, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 6, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 7, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 8, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 9, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 10, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 11, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 12, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 13, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 14, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 6, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 7, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 8, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 9, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 10, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 11, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 12, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 13, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 14, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 15, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 7, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 8, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 9, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 10, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 11, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 12, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 13, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 14, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 15, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 16, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 8, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 9, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 10, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 11, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 12, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 13, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 14, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 15, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 16, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 17, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 9, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 10, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 11, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 12, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 13, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 14, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 15, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 16, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 17, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 18, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 10, answer: 89, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 11, answer: 88, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 12, answer: 87, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 13, answer: 86, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 14, answer: 85, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 15, answer: 84, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 16, answer: 83, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 17, answer: 82, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 18, answer: 81, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 19, answer: 80, format: types.Format.Equation1, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 3, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 4, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 5, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 6, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 7, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 8, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 9, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.SUB, numB: 10, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 3, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 4, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 5, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 6, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 7, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 8, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 9, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 10, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.SUB, numB: 11, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 5, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 6, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 7, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 8, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 9, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 10, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 11, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.SUB, numB: 12, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 4, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 5, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 6, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 7, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 8, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 9, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 10, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 11, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 12, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 13, sign: mathSymbols.SUB, numB: 13, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 5, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 6, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 7, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 8, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 9, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 10, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 11, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 12, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 13, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.SUB, numB: 14, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 6, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 7, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 8, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 9, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 10, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 11, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 12, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 13, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 14, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.SUB, numB: 15, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 7, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 8, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 9, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 10, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 11, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 12, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 13, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 14, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 15, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.SUB, numB: 16, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 8, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 9, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 10, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 11, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 12, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 13, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 14, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 15, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 16, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 17, sign: mathSymbols.SUB, numB: 17, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 9, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 10, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 11, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 12, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 13, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 14, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 15, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 16, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 17, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.SUB, numB: 18, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 10, answer: 9, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 11, answer: 8, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 12, answer: 7, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 13, answer: 6, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 14, answer: 5, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 15, answer: 4, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 16, answer: 3, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 17, answer: 2, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 18, answer: 1, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 19, sign: mathSymbols.SUB, numB: 19, answer: 0, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 1, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 2, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 3, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 4, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 5, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 6, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 7, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 8, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 9, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.SUB, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 2, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 3, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 4, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 5, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 6, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 7, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 8, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 9, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 10, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.SUB, numB: 11, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 3, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 4, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 5, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 6, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 7, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 8, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 9, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 10, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 11, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.SUB, numB: 12, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 4, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 5, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 6, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 7, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 8, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 9, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 10, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 11, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 12, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 23, sign: mathSymbols.SUB, numB: 13, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 5, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 6, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 7, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 8, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 9, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 10, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 11, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 12, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 13, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.SUB, numB: 14, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 6, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 7, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 8, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 9, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 10, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 11, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 12, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 13, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 14, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.SUB, numB: 15, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 7, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 8, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 9, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 10, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 11, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 12, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 13, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 14, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 15, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 26, sign: mathSymbols.SUB, numB: 16, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 8, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 9, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 10, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 11, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 12, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 13, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 14, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 15, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 16, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.SUB, numB: 17, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 9, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 10, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 11, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 12, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 13, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 14, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 15, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 16, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 17, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.SUB, numB: 18, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 10, answer: 19, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 11, answer: 18, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 12, answer: 17, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 13, answer: 16, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 14, answer: 15, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 15, answer: 14, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 16, answer: 13, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 17, answer: 12, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 18, answer: 11, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 29, sign: mathSymbols.SUB, numB: 19, answer: 10, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 1, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 2, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 3, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 4, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 5, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 6, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 7, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 8, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 9, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.SUB, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 2, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 3, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 4, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 5, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 6, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 7, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 8, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 9, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 10, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 31, sign: mathSymbols.SUB, numB: 11, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 3, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 4, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 5, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 6, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 7, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 8, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 9, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 10, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 11, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.SUB, numB: 12, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 4, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 5, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 6, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 7, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 8, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 9, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 10, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 11, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 12, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.SUB, numB: 13, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 5, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 6, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 7, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 8, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 9, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 10, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 11, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 12, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 13, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 34, sign: mathSymbols.SUB, numB: 14, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 6, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 7, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 8, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 9, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 10, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 11, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 12, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 13, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 14, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.SUB, numB: 15, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 7, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 8, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 9, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 10, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 11, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 12, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 13, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 14, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 15, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.SUB, numB: 16, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 8, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 9, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 10, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 11, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 12, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 13, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 14, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 15, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 16, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 37, sign: mathSymbols.SUB, numB: 17, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 9, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 10, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 11, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 12, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 13, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 14, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 15, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 16, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 17, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 38, sign: mathSymbols.SUB, numB: 18, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 10, answer: 29, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 11, answer: 28, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 12, answer: 27, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 13, answer: 26, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 14, answer: 25, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 15, answer: 24, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 16, answer: 23, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 17, answer: 22, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 18, answer: 21, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 39, sign: mathSymbols.SUB, numB: 19, answer: 20, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 1, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 2, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 3, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 4, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 5, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 6, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 7, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 8, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 9, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.SUB, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 2, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 3, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 4, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 5, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 6, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 7, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 8, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 9, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 10, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 41, sign: mathSymbols.SUB, numB: 11, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 3, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 4, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 5, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 6, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 7, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 8, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 9, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 10, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 11, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.SUB, numB: 12, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 4, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 5, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 6, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 7, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 8, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 9, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 10, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 11, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 12, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 43, sign: mathSymbols.SUB, numB: 13, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 5, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 6, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 7, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 8, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 9, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 10, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 11, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 12, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 13, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.SUB, numB: 14, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 6, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 7, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 8, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 9, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 10, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 11, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 12, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 13, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 14, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.SUB, numB: 15, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 7, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 8, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 9, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 10, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 11, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 12, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 13, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 14, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 15, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 46, sign: mathSymbols.SUB, numB: 16, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 8, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 9, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 10, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 11, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 12, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 13, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 14, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 15, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 16, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 47, sign: mathSymbols.SUB, numB: 17, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 9, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 10, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 11, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 12, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 13, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 14, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 15, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 16, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 17, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.SUB, numB: 18, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 10, answer: 39, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 11, answer: 38, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 12, answer: 37, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 13, answer: 36, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 14, answer: 35, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 15, answer: 34, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 16, answer: 33, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 17, answer: 32, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 18, answer: 31, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.SUB, numB: 19, answer: 30, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 1, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 2, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 3, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 4, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 5, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 6, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 7, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 8, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 9, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.SUB, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 2, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 3, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 4, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 5, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 6, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 7, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 8, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 9, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 10, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 51, sign: mathSymbols.SUB, numB: 11, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 3, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 4, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 5, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 6, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 7, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 8, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 9, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 10, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 11, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 52, sign: mathSymbols.SUB, numB: 12, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 4, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 5, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 6, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 7, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 8, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 9, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 10, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 11, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 12, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 53, sign: mathSymbols.SUB, numB: 13, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 5, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 6, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 7, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 8, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 9, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 10, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 11, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 12, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 13, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.SUB, numB: 14, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 6, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 7, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 8, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 9, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 10, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 11, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 12, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 13, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 14, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.SUB, numB: 15, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 7, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 8, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 9, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 10, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 11, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 12, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 13, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 14, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 15, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.SUB, numB: 16, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 8, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 9, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 10, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 11, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 12, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 13, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 14, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 15, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 16, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 57, sign: mathSymbols.SUB, numB: 17, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 9, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 10, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 11, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 12, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 13, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 14, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 15, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 16, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 17, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 58, sign: mathSymbols.SUB, numB: 18, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 10, answer: 49, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 11, answer: 48, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 12, answer: 47, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 13, answer: 46, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 14, answer: 45, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 15, answer: 44, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 16, answer: 43, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 17, answer: 42, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 18, answer: 41, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 59, sign: mathSymbols.SUB, numB: 19, answer: 40, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 1, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 2, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 3, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 4, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 5, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 6, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 7, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 8, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 9, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.SUB, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 2, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 3, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 4, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 5, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 6, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 7, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 8, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 9, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 10, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 61, sign: mathSymbols.SUB, numB: 11, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 3, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 4, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 5, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 6, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 7, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 8, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 9, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 10, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 11, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 62, sign: mathSymbols.SUB, numB: 12, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 4, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 5, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 6, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 7, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 8, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 9, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 10, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 11, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 12, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.SUB, numB: 13, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 5, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 6, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 7, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 8, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 9, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 10, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 11, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 12, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 13, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.SUB, numB: 14, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 6, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 7, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 8, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 9, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 10, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 11, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 12, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 13, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 14, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 65, sign: mathSymbols.SUB, numB: 15, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 7, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 8, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 9, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 10, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 11, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 12, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 13, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 14, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 15, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.SUB, numB: 16, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 8, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 9, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 10, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 11, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 12, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 13, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 14, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 15, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 16, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 67, sign: mathSymbols.SUB, numB: 17, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 9, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 10, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 11, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 12, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 13, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 14, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 15, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 16, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 17, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 68, sign: mathSymbols.SUB, numB: 18, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 10, answer: 59, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 11, answer: 58, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 12, answer: 57, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 13, answer: 56, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 14, answer: 55, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 15, answer: 54, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 16, answer: 53, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 17, answer: 52, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 18, answer: 51, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 69, sign: mathSymbols.SUB, numB: 19, answer: 50, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 1, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 2, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 3, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 4, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 5, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 6, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 7, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 8, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 9, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.SUB, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 2, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 3, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 4, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 5, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 6, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 7, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 8, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 9, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 10, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 71, sign: mathSymbols.SUB, numB: 11, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 3, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 4, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 5, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 6, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 7, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 8, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 9, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 10, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 11, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.SUB, numB: 12, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 4, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 5, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 6, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 7, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 8, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 9, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 10, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 11, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 12, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 73, sign: mathSymbols.SUB, numB: 13, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 5, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 6, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 7, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 8, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 9, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 10, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 11, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 12, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 13, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 74, sign: mathSymbols.SUB, numB: 14, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 6, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 7, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 8, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 9, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 10, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 11, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 12, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 13, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 14, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 75, sign: mathSymbols.SUB, numB: 15, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 7, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 8, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 9, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 10, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 11, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 12, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 13, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 14, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 15, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 76, sign: mathSymbols.SUB, numB: 16, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 8, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 9, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 10, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 11, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 12, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 13, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 14, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 15, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 16, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.SUB, numB: 17, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 9, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 10, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 11, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 12, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 13, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 14, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 15, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 16, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 17, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 78, sign: mathSymbols.SUB, numB: 18, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 10, answer: 69, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 11, answer: 68, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 12, answer: 67, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 13, answer: 66, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 14, answer: 65, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 15, answer: 64, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 16, answer: 63, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 17, answer: 62, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 18, answer: 61, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 79, sign: mathSymbols.SUB, numB: 19, answer: 60, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 1, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 2, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 3, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 4, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 5, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 6, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 7, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 8, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 9, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.SUB, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 2, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 3, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 4, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 5, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 6, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 7, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 8, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 9, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 10, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.SUB, numB: 11, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 3, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 4, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 5, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 6, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 7, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 8, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 9, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 10, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 11, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 82, sign: mathSymbols.SUB, numB: 12, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 4, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 5, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 6, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 7, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 8, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 9, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 10, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 11, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 12, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 83, sign: mathSymbols.SUB, numB: 13, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 5, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 6, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 7, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 8, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 9, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 10, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 11, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 12, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 13, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.SUB, numB: 14, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 6, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 7, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 8, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 9, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 10, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 11, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 12, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 13, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 14, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 85, sign: mathSymbols.SUB, numB: 15, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 7, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 8, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 9, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 10, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 11, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 12, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 13, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 14, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 15, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 86, sign: mathSymbols.SUB, numB: 16, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 8, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 9, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 10, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 11, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 12, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 13, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 14, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 15, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 16, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 87, sign: mathSymbols.SUB, numB: 17, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 9, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 10, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 11, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 12, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 13, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 14, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 15, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 16, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 17, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.SUB, numB: 18, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 10, answer: 79, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 11, answer: 78, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 12, answer: 77, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 13, answer: 76, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 14, answer: 75, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 15, answer: 74, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 16, answer: 73, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 17, answer: 72, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 18, answer: 71, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 89, sign: mathSymbols.SUB, numB: 19, answer: 70, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 1, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 2, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 3, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 4, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 5, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 6, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 7, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 8, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 9, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.SUB, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 2, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 3, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 4, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 5, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 6, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 7, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 8, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 9, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 10, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 91, sign: mathSymbols.SUB, numB: 11, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 3, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 4, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 5, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 6, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 7, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 8, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 9, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 10, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 11, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 92, sign: mathSymbols.SUB, numB: 12, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 4, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 5, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 6, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 7, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 8, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 9, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 10, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 11, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 12, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 93, sign: mathSymbols.SUB, numB: 13, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 5, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 6, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 7, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 8, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 9, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 10, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 11, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 12, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 13, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 94, sign: mathSymbols.SUB, numB: 14, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 6, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 7, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 8, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 9, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 10, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 11, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 12, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 13, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 14, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 95, sign: mathSymbols.SUB, numB: 15, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 7, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 8, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 9, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 10, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 11, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 12, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 13, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 14, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 15, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.SUB, numB: 16, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 8, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 9, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 10, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 11, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 12, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 13, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 14, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 15, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 16, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 97, sign: mathSymbols.SUB, numB: 17, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 9, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 10, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 11, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 12, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 13, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 14, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 15, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 16, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 17, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 98, sign: mathSymbols.SUB, numB: 18, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 10, answer: 89, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 11, answer: 88, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 12, answer: 87, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 13, answer: 86, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 14, answer: 85, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 15, answer: 84, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 16, answer: 83, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 17, answer: 82, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 18, answer: 81, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.SUB, numB: 19, answer: 80, format: types.Format.Equation2, hint: types.Hint.TWO_BASE_TENS_SUBTRACTION
  } as types.Question
];